import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { PermissionsEnum } from '../../../api/api-reference';
import { AuthService } from '../../../services/auth.service';
import { ThemeService } from '../../../services/theme.service';
import { Theme } from '../../core/enums/theme.enum';

@Component({
  selector: 'app-account-appearance',
  standalone: true,
  imports: [HttpClientModule, TranslateModule, CommonModule],
  templateUrl: './account-appearance.component.html',
  styleUrl: './account-appearance.component.scss',
})
export class AccountAppearanceComponent {
  Theme = Theme;
  selectedTheme = '';
  PermissionEnum = PermissionsEnum;

  constructor(
    private themeService: ThemeService,
    public authService: AuthService,
  ) {
    this.selectedTheme = themeService.getTheme();
  }

  onRadioChange(theme: Theme) {
    this.selectedTheme = theme;
    if (this.selectedTheme === Theme.Light) {
      this.themeService.setTheme(Theme.Light);
      this.selectedTheme = Theme.Light;
    } else if (this.selectedTheme === Theme.Dark) {
      this.themeService.setTheme(Theme.Dark);
      this.selectedTheme = Theme.Dark;
    } else if (this.selectedTheme === Theme.System) {
      this.themeService.setTheme(Theme.System);
      this.selectedTheme = Theme.System;
    }
  }
}
